// Action to toggle the tutorial state
export const togglePopup = () => {
    return {
      type: 'TOGGLE_POPUP1', // Action type
    };
  };
  
  // Action to explicitly set the tutorial state (expanded or collapsed)
  export const setPopup = (value) => {
    return {
      type: 'SET_POPUP1', // Action type
      payload: value, // Pass the new state as payload
    };
  };